// API base URL (no trailing slash).
// 1) Use REACT_APP_API_URL from env if set (.env.development for npm start, .env.production for build).
// 2) Local (localhost): if env not set, use production API so you can test against production without .env or build.
// 3) Live site (trucker.rockprosusa.com): always use production API so data matches local testing.
const PRODUCTION_API_BASE = "https://api.rockprosusa.com";
const fromEnv = (process.env.REACT_APP_API_URL || "").trim().replace(/\/$/, "");
const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
const isProductionTruckerHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "trucker.rockprosusa.com" ||
    window.location.hostname === "www.trucker.rockprosusa.com");
const fromHost = isProductionTruckerHost || (isLocalhost && !fromEnv) ? PRODUCTION_API_BASE : "";
const apiBase = fromEnv || fromHost;

export const BASE_URL = apiBase ? `${apiBase}/` : "/";
export const API_URL1 = `${BASE_URL}api/`;
export const SOCKET_URL = BASE_URL;


